/**
 * Office JSON populate function
 */

declare const AJAX_BASE: string;

import { reservaD } from "./variables.js";
import { ajax_offices } from "./ajax.js";
import { showError, dId, logger } from "./utils.js";
import { provincias_index, ciudades_index, ciudad_dropdown_furgo, ciudad_dropdown_turismo } from "./variables.js";
import { add_ciudades_listeners } from "./ciudades.js";

async function load_dd_offices() {

  logger("Load offices");

  // Load AJAX office options: 
  let res = await ajax_offices( reservaD[86] );

  if (res[0] == "ERROR") {
    showError("error descargando oficinas");
    return;
  }

  create_ciudades_lists(res);
  add_ciudades_listeners();

}



/**
 * Dropdown lists for ciudad / provincia autocomplete
 * Update when switching from Turismos to Furgonetas
 **/
  function create_ciudades_lists(res_ary: string[]) {

    logger("create ciudades lists from JSON");


    res_ary.forEach( (elem) => {

      let city_prov = elem[0].split("|");
      let pretty_city = city_prov[0] + " (" + city_prov[1] + ")";
      
      // needed for ajax pretty provincia names and search again.
      provincias_index[ parseInt(elem[2]) ] = city_prov[1];       // ! This might not be used

      // Reverse Lookup city once selected
      // [city match, city name, provincia name, provincia int, (ciudad int), (tipo)]
      let srch_elem = [ pretty_city, city_prov[0], city_prov[1], elem[2], elem[1] ];
      ciudades_index.push(srch_elem); // global

      if (elem[1] == "1" || elem[1] == "3") {
        ciudad_dropdown_turismo.push( pretty_city); // global
      }

      if (elem[1] == "2" || elem[1] == "3") {
        ciudad_dropdown_furgo.push( pretty_city);  // global
      }

    });

    logger("Ciudades Count:" + ciudades_index.length + "\nFurgo Count:" + ciudad_dropdown_turismo.length + "\nTurismo Count:" + ciudad_dropdown_furgo.length);

  }



  function check_same_office() {

    const oneway = (<HTMLInputElement>dId("sel_misma_oficina")).checked;

    logger("Oneway: " + oneway);

    if (!oneway) {

      reservaD[16] = "1000";
      reservaD[11] = "1000";  // reservaD[6]; ... Have to set to numeric for reverse compatibility (server)
      
      ( <HTMLInputElement>dId("d_ciudad")).value = "same as salida";
     
      ( <HTMLElement>dId("search_oficina_devolucion")).classList.add("oficina-hidden");
      ( <HTMLElement>dId("search_oficina_salida")).classList.add("oficina-expanded");

    } else {

      reservaD[16] = "";
      ( <HTMLInputElement>dId("d_ciudad")).value = "";
      ( <HTMLInputElement>dId("oficina_devolucion_selector")).value = "";

      ( <HTMLElement>dId("search_oficina_devolucion")).classList.remove("oficina-hidden");
      ( <HTMLElement>dId("search_oficina_salida")).classList.remove("oficina-expanded");

    }

  }


  export { load_dd_offices, check_same_office };